import {createContext, useContext, useMemo, useState} from 'react';

import AppContext from 'components/App/AppContext';
import {BasicAddressBill} from './BasicAddressBill';
import {BasicAddressStandard} from './BasicAddressStandard';
import {AddressStyles} from '../Address/AddressStyles';
import {BasicAddressLanding} from './BasicAddressLanding';
import {BasicAddressHouse} from './BasicAddressHouse';
import {BasicAddressConfirm} from './BasicAddressConfirm';
import BasicAddressMobile from './BasicAddressMobile';

export const STEPS = {
    HOME: 'HOME',
    ADDRESS_STANDARD: 'ADDRESS_STANDARD',
    BILL: 'BILL',
    HOUSE: 'HOUSE',
    CONFIRM: 'CONFIRM',
};

export const BasicAddressContext = createContext({
    currentStep: '',
    isContinue: false,
    setCurrentStep: () => {},
    result: {},
    setResult: () => {},
    handleStep: () => {},
});

export const BasicAddressContent = ({values = {}, step = STEPS.HOME, isContinue}) => {
    const [currentStep, setCurrentStep] = useState(step);
    const [result, setResult] = useState({...values});

    const {colors} = useContext(AppContext);

    const handleStep = ({step, data = {}}) => {
        setResult(prev => ({...prev, ...data}));
        setCurrentStep(step);
    };

    const value = useMemo(
        () => ({
            currentStep,
            setCurrentStep,
            result,
            setResult,
            isContinue,
            handleStep,
        }),
        [currentStep, result, isContinue]
    );

    const renderSteps = () => {
        switch (currentStep) {
            default:
            case STEPS.HOME:
                return <BasicAddressLanding />;
            case STEPS.ADDRESS_STANDARD:
                return <BasicAddressStandard />;
            case STEPS.BILL:
                return (
                    <BasicAddressMobile>
                        <BasicAddressBill />
                    </BasicAddressMobile>
                );
            case STEPS.HOUSE:
                return (
                    <BasicAddressMobile>
                        <BasicAddressHouse />
                    </BasicAddressMobile>
                );
            case STEPS.CONFIRM:
                return <BasicAddressConfirm />;
        }
    };

    return (
        <BasicAddressContext.Provider value={value}>
            <AddressStyles colors={colors}>{renderSteps()}</AddressStyles>
        </BasicAddressContext.Provider>
    );
};

export const BasicAddressHeader = ({title, text, cls = ''}) => {
    return (
        <div className={`address-header ${cls}`}>
            <h4>{title}</h4>
            <span>{text}</span>
        </div>
    );
};
